import { isArray, isNull } from "../../util/TypeUtil";
import Content from "./Content";
import ContentFactory from "./ContentFactory";
import ContentTypes from "./ContentTypes";

/**
* KeyMomentChoiceContent.js
* 
* Created on Oct 8, 2013, 12:16:21 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
export default class KeyMomentChoiceContent extends Content {
    constructor(languagePack, contentID, label) {
        super(KeyMomentChoiceContent.NAME, KeyMomentChoiceContent.TYPE, label, languagePack, contentID);
        this._scoreVariables = [];
    }

    /*
     * 
     * @returns {undefined}
     */
    remove() {
        this.removeLanguagePackText(KeyMomentChoiceContent.KEY_MOMENT_ID_LABEL);
        this.removeLanguagePackText(KeyMomentChoiceContent.SITUATION_LABEL);
        this.removeLanguagePackText(KeyMomentChoiceContent.CHOICE_LABEL);
        this.removeLanguagePackText(KeyMomentChoiceContent.TIP_LABEL);
        this.removeLanguagePackText(KeyMomentChoiceContent.IMAGE_LABEL);
        super.remove();

    }

    /*
     * 
     * @returns {KeyMomentChoiceContent}
     */
    clone() {
        const clone = ContentFactory.getContent(ContentTypes.TYPE_KEY_MOMENT_CHOICE, this.getLanguagePack());
        clone.setContentID(this.getContentID());
        clone.setSituationDescription(this.getSituationDescription());
        clone.setChoice(this.getChoice());
        clone.setTip(this.getTip());
        clone.setImage(this.getGetImage());

        for (let i = 0; i <= this.getScoreVariables().length; i++) {
            clone.getScoreVariables().push(this.getScoreVariables()[i].clone());
        }

        return clone;
    }

    /*
     * Returns the score variables
     * @returns {Array}
     */
    getScoreVariables() {
        return this._scoreVariables;
    }

    /*
     * Setter for the score variables
     * @param {type} scoreVariables
     * @returns {undefined}
     */
    setScoreVariables(scoreVariables) {
        this._scoreVariables = scoreVariables;
    }

    /*
     * 
     * @param {type} property
     * @returns {unresolved}
     */
    getValueForProperty(property) {
        return this.getLanguagePackText(property);
    }

    /*
     * 
     * @param {String} property
     * @param {*} value
     * @returns {undefined}
     */
    setValueForProperty(property, value) {
        if (this.getValueForProperty(property) !== value) {
            this.setLanguagePackText(property, value);
        }
    }

    /*
     * 
     * @returns {*}
     */
    getKeyMomentID() {
        return this.getValueForProperty(KeyMomentChoiceContent.KEY_MOMENT_ID_LABEL);
    }

    /*
     * 
     * @param {type} value
     * @returns {undefined}
     */
    setKeyMomentID(value) {
        this.setValueForProperty(KeyMomentChoiceContent.KEY_MOMENT_ID_LABEL, value);
    }

    /*
     * 
     * @returns {unresolved}
     */
    getImage() {
        return this.getValueForProperty(KeyMomentChoiceContent.IMAGE_LABEL);
    }

    /*
     * 
     * @param {type} value
     * @returns {undefined}
     */
    setImage(value) {
        this.setValueForProperty(KeyMomentChoiceContent.IMAGE_LABEL, value);
    }

    /*
     * 
     * @returns {unresolved}
     */
    getSituationDescription() {
        return this.getValueForProperty(KeyMomentChoiceContent.SITUATION_LABEL);
    }

    /* 
     * @param {type} value
     * @returns {undefined}
     */
    setSituationDescription(value) {
        this.setValueForProperty(KeyMomentChoiceContent.SITUATION_LABEL, value);
    }

    /*
     * 
     * @returns {unresolved}
     */
    getChoice() {
        return this.getValueForProperty(KeyMomentChoiceContent.CHOICE_LABEL);
    }

    /*
     * 
     * @param {type} value
     * @returns {undefined}
     */
    setChoice(value) {
        this.setValueForProperty(KeyMomentChoiceContent.CHOICE_LABEL, value);
    }

    /*
     * 
     * @returns {unresolved}
     */
    getTip() {
        return this.getValueForProperty(KeyMomentChoiceContent.TIP_LABEL);
    }

    /*
     * 
     * @param {type} value
     * @returns {undefined}
     */
    setTip(value) {
        this.setValueForProperty(KeyMomentChoiceContent.TIP_LABEL, value);
    }

    /*
     * @returns {*}
     */
    convertToObject() {
        const object = super.convertToObject();
        object.scoreVariables = [];
        for (let i = 0; i < this._scoreVariables.length; i++) {
            object.scoreVariables[i] = this._scoreVariables[i].convertToObject();
        }
        // TODO
        //object["choice"] = this._choice;
        //object["image"] = this._image;
        //object["tip"] = this._tip;
        //object["situationDescription"] = this._situationDescription;
        return object;
    }

    setPropertiesFromObject(object) {
        if (!isNull(object.scoreVariables) && isArray(object.scoreVariables)) {
            for (let i = 0; i < object.scoreVariables.length; i++) {
                this._scoreVariables[i] = ContentFactory.getContentFromObject(object.scoreVariables[i], this.getLanguagePack());
            }
            delete object.scoreVariables;
        }

        super.setPropertiesFromObject(object);
    }

    getDescriptionLabel() {
        let label;
        label = this.getChoice().toString();
        if (!label || label === "") {
            label = "Key Moment Choice: <NO CHOICE>";
        }
        else {
            label = `Key Moment Choice: ${label}`;
        }
        return label;
    }
}



KeyMomentChoiceContent.TYPE = ContentTypes.TYPE_KEY_MOMENT_CHOICE;
KeyMomentChoiceContent.NAME = "Key Moment Choice";
KeyMomentChoiceContent.KEY_MOMENT_ID_LABEL = "keyMomentID";
KeyMomentChoiceContent.SITUATION_LABEL = "situationText";
KeyMomentChoiceContent.CHOICE_LABEL = "choice";
KeyMomentChoiceContent.TIP_LABEL = "tip";
KeyMomentChoiceContent.IMAGE_LABEL = "image";